import script from "./buildGroupFilter.vue?vue&type=script&setup=true&lang=ts"
export * from "./buildGroupFilter.vue?vue&type=script&setup=true&lang=ts"

import "./buildGroupFilter.vue?vue&type=style&index=0&id=07b4bf48&scoped=true&lang=scss"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07b4bf48"]])

export default __exports__